import { createAction, createSlice, } from "@reduxjs/toolkit";
const initialState ={
    loading: true,
    error:"",
    speechConfigList :[],
}

export const speechConfigSlice = createSlice({
    name:"speechConfig",
    initialState,
    reducers:{
        setIsLoading(state,action){
            state.loading = action.payload;
        },
        setSpeechConfig(state,action){
            let data = action.payload;
            state.speechConfigList = data;
            state.loading = false;
        },
        setCurrentSpeechConfig(state, action) {
            let { id } = action.payload;
            state.current = state.speechConfigList.find(e => e.id == id);
            const index = state.speechConfigList.findIndex(obj => obj.id === id);
            state.index = index;
        },
        updateSetSpeechConfig(state, action) {
            state.speechConfigList = state.speechConfigList.map((item, index) => 
            index === state.index ? { ...item, ...action.payload.speech } : item);
            state.loading = false;
        },
       
    }
})

export const speechAction = {
    loadSpeechConfig: createAction(`${speechConfigSlice.name}/loadSpeechConfig`, (payload) => ({ payload })),
    setSpeechConfig: speechConfigSlice.actions.setSpeechConfig,
    loadCurrentSpeechConfig: speechConfigSlice.actions.setCurrentSpeechConfig,
    saveCurrentSpeechConfig: speechConfigSlice.actions.updateSetSpeechConfig,
    setCurrentSpeechConfig: speechConfigSlice.actions.setCurrentSpeechConfig,
}

export const getSpeechConfig = (state) => state.speechConfig.speechConfigList;
export const getCurrentSpeechConfig = (state) => state.speechConfig.current;
export const isLoading = (state) => state.speechConfig.loading;

export default speechConfigSlice.reducer;